import { render, staticRenderFns } from "./SvgMap.vue?vue&type=template&id=363f2498&scoped=true"
import script from "./SvgMap.vue?vue&type=script&lang=js"
export * from "./SvgMap.vue?vue&type=script&lang=js"
import style0 from "./SvgMap.vue?vue&type=style&index=0&id=363f2498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363f2498",
  null
  
)

export default component.exports